/**
 * Wysokości SpacingBlock per breakpoint (jak w Theme UI: mobile → widescreen).
 * Klucz = wartość z CMS (`height` / margin token).
 */
export const SPACING_BLOCK_HEIGHT_MAP: Record<string, readonly string[]> = {
  '116': ['64px', '80px', '61.87px', '77.33px', '87px', '116px'],
  '80': ['48px', '64px', '42px', '54px', '60px', '80px'],
  '64': ['32px', '40px', '34.13px', '42.67px', '48px', '64px'],
  '40': ['24px', '24px', '21px', '27px', '30px', '40px'],
  '24': ['16px', '24px', '12px', '16px', '20px', '24px']
};
const BP_COUNT = 6;
function parsePxToken(value: string): number {
  const n = parseFloat(String(value).replace(/px/gi, '').trim());
  return Number.isFinite(n) ? n : 0;
}

/** Rzeczywiste px na każdym z 6 breakpointów dla tokenu CMS; brak mapy → stała wartość na wszystkich. */
export function spacingHeightsPxPerBreakpoint(token?: number): number[] | null {
  if (token == null || !Number.isFinite(token) || token <= 0) return null;
  const key = String(token);
  const row = SPACING_BLOCK_HEIGHT_MAP[key];
  if (row) return row.map(parsePxToken);
  return Array(BP_COUNT).fill(token);
}

/** `height` dla sekcji fullscreen: `calc(100vh - suma)` zgodna z faktycznymi wysokościami SpacingBlock per breakpoint. */
export function fullscreenSectionHeightMinusMargins(marginTop?: number, marginBottom?: number): string | string[] {
  const topPx = spacingHeightsPxPerBreakpoint(marginTop);
  const bottomPx = spacingHeightsPxPerBreakpoint(marginBottom);
  if (!topPx && !bottomPx) return '100vh';
  return Array.from({
    length: BP_COUNT
  }, (_, i) => {
    const sum = (topPx ? topPx[i] : 0) + (bottomPx ? bottomPx[i] : 0);
    return sum > 0 ? `calc(100vh - ${sum}px)` : '100vh';
  });
}